import { React, useState, useEffect, Card, Avatar, Toast, Breadcrumb, CustomTable, _formatDate, showCustomConfirmMessage, CustomModal, Icon, useUser } from "../utils/commonImports";
import dayjs from "dayjs";
import { _api } from '../auth/Api';
import { Input, DatePicker, Button, Alert } from "antd";
import Select from "react-select";
import { customStyleMd } from "../utils/common";
import { getPageRights } from "../utils/accessPages";
import { _exportToExcel } from "../helper/ExportToExcel";

const serviceOptions = [
  { value: "Paint and Body Repairs", label: "Paint and Body Repairs" },
  { value: "Brake System Maintenance", label: "Brake System Maintenance" },
  { value: "Battery Replacement", label: "Battery Replacement" },
  { value: "Periodic Maintenance", label: "Periodic Maintenance" },
  { value: "General Maintenance", label: "General Maintenance" },
  { value: "General Repair", label: "General Repair" },
  { value: "Car Wash", label: "Car Wash" },
  { value: "Body & Paints", label: "Body & Paints" },
];

const statusOptions = [
  { value: "pending", label: "Pending" },
  { value: "inProgress", label: "In Progress" },
  { value: "completed", label: "Completed" },
];
const Appointments = () => {
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [totalRecords, setTotalRecords] = useState(0);
  const [appointments, setAppointments] = useState([]);
  const [vehicleOptions, setVehicleOptions] = useState([]);
  const [filterBtnShow, setFilterBtnShow] = useState(true);
  const [showExp, setShowExp] = useState({ isShow: false, msg: "" });
  const [isModalOpen, setIsModalOpen] = useState({ isOpen: false, data: {} });
  const [filters, setFilters] = useState({
    customerName: "",
    contactNumber: "",
    email: "",
    serviceType: null,
    status: null,
    vehicleName: "",
    isCreatedDate: null,
    dateTo: null,
    dateFrom: null,
  });
  useEffect(() => {
    _getAppointments();
    _getVehicles();
  }, []);

  const { loggedInUser } = useUser();
  const userPages = loggedInUser?.roles?.[0]?.pages || [];

  const rights = getPageRights(userPages, 7);

  const launchDetailModal = (open, data = {}) => {
    setIsModalOpen({ isOpen: open, data });
  };
  const handleTableChange = (pagination) => {
    setPage(pagination.current);
    setPageSize(pagination.pageSize);
    _getAppointments(filters, pagination.current, pagination.pageSize);
  };
  const handleApply = () => {
    const { customerName, contactNumber, email, serviceType, status, vehicleName, isCreatedDate, dateTo, dateFrom } = filters;
    if (!customerName && !contactNumber && !email && !serviceType && !status && !vehicleName && !isCreatedDate && !dateTo && !dateFrom) {
      // Toast.fire({ icon: "warning", title: "Please fill at least one filter" });
      setShowExp({ isShow: true, msg: "NOTE: Please fill at least one filter" })
      return;
    }
    if (isCreatedDate && !dateTo && !dateFrom) {
      setShowExp({ isShow: true, msg: "NOTE: Please select (to) & (from) Date too." })
      return;
    }
    setPage(1);
    _getAppointments(filters, 1, pageSize);
  };

  const handleReset = () => {
    setShowExp({ isShow: false, msg: "" })
    const resetFilters = { customerName: "", contactNumber: "", email: "", serviceType: null, status: "", vehicleName: "", isCreatedDate: null, dateTo: null, dateFrom: null, };
    setFilters(resetFilters);
    setPage(1);
    _getAppointments(resetFilters, 1, pageSize);
  };

  const _getVehicles = async () => {
    try {
      await _api("GET", "Vehicle/GetDistinctVehicles", null, (res) => {
        if (res.isSuccess) {
          const List = res.data.map((v) => ({
            value: v.id,
            label: v.itemName,
          }));
          setVehicleOptions(List);
        }
      });
    } catch (error) {
      console.log("API Error", error?.message);
    }
  };

  const _getAppointments = async (filterValues = {}, pageNo = page, numberOfRecords = pageSize) => {
    setLoading(true);
    const payload = {
      appointmentId: 0,
      customerName: filterValues.customerName || "",
      contactNumber: filterValues.contactNumber || "",
      email: filterValues.email || "",
      serviceType: filterValues.serviceType?.value || "",
      status: filterValues.status?.label || "",
      vehicleName: filterValues.vehicleName || "",
      isCreatedDate: filterValues.isCreatedDate?.value,
      preferredDateTo: filterValues.dateTo ? dayjs(filterValues.dateTo).format("YYYY-MM-DD") : null,
      preferredDateFrom: filterValues.dateFrom ? dayjs(filterValues.dateFrom).format("YYYY-MM-DD") : null,
      createdDateTo: filterValues.dateTo ? dayjs(filterValues.dateTo).format("YYYY-MM-DD") : null,
      createdDateFrom: filterValues.dateFrom ? dayjs(filterValues.dateFrom).format("YYYY-MM-DD") : null,
      page: {
        pageNo: pageNo,
        numberOfRecords: numberOfRecords,
      },
    };
    try {
      await _api("POST", "Appointment/GetAppointmentsById", payload, (res) => {
        if (res.isSuccess) {
          setAppointments(res.data);
          setTotalRecords(res.totalRecords || 0);
        } else {
          setAppointments([]);
          // Toast.fire({ icon: "error", title: res.message });
        }
      });
    } catch (error) {
      console.error(error);
      // setAppointments([]);
      // Toast.fire({ icon: "error", title: "Failed to fetch appointments" });
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Customer", dataIndex: "customerName",
      render: (_, record) => (
        <div className="d-flex align-items-center gap-2">
          <Avatar src={null}>
            {record.customerName?.charAt(0).toUpperCase()}
          </Avatar>
          <div>{record.customerName}</div>
        </div>
      ),
    },
    {
      title: "Contact Info", dataIndex: "email",
      render: (_, record) => (
        <div>
          <div className="small">{record.contactNumber}</div>
          <div className="text-muted small">{record.email}</div>
        </div>
      ),
    },
    //{ title: "Vehicle", dataIndex: "vehicleName", },
    //{ title: "Service Type", dataIndex: "serviceType", },
    {
      title: "Vehicle & Service Type", dataIndex: "vehicleName", render: (_, row) => (
        <div className="d-flex flex-column">
          <span style={{ fontSize: "14px" }}>
            {row.serviceType}
          </span>
          <span style={{ fontSize: "12px", color: "#6c757d" }}>
            {row?.vehicleName}
          </span>
        </div>
      )
    },
    // { title: "Mileage", dataIndex: "currentMileage", },
    // { title: "Preferred Date", dataIndex: "preferredDate", render: (date) => _formatDate(date), },
    // {
    //   title: "Preferred Time", dataIndex: "preferredTimeSlot",
    //   render: (time) => time ? dayjs(`2000-01-01${time}`, 'YYYY-MM-DD:HH:mm').format('hh:mm A') : "-",
    // },
    {
      title: "Status", dataIndex: "status",
      render: (status) => (
        <span className={`badge ${status === 'Confirmed' ? 'bg-success' : status === 'Rejected' ? 'bg-danger' : 'bg-warning'}`}> {status || "Unknown"} </span>
      ),
    },
    {
      title: "Created On",
      dataIndex: "createDate",
      render: (createDate) => _formatDate(createDate)
    },
    {
      title: "Scheduled On", dataIndex: "preferredDate", render: (_, row) => (
        <div className="d-flex flex-column">
          <span style={{ fontSize: "14px" }}>
            {_formatDate(row?.preferredDate)}
          </span>
          <span style={{ fontSize: "12px", color: "#6c757d" }}>
            {row?.preferredTimeSlot ? dayjs(row?.preferredTimeSlot, 'HH:mm:ss').format('hh:mm A') : '-'}
          </span>
        </div>
      )
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        record.status === "Pending" ? (
          <div className="d-flex gap-2">
            <Button size="small" icon={<Icon icon="feather:eye" />} onClick={() => launchDetailModal(true, record)} />
            {rights && rights?.edit ? (
              <>
                <Button onClick={() => handleStatusUpdate(record, "Confirmed")} size="small" className="btn-outline-success" icon={<Icon icon="feather:check" />} />
                <Button onClick={() => handleStatusUpdate(record, "Rejected")} size="small" danger icon={<Icon icon="feather:x" />} />
              </>
            ) : (
              <Button size="small" disabled title="Action Not Allowed">Not Allowed</Button>
            )}
          </div>
        ) : (
          <div className="d-flex gap-2 align-items-center">
            <Button size="small" icon={<Icon icon="feather:eye" />} onClick={() => launchDetailModal(true, record)} />
            <Icon icon="mdi:file-check-outline" fontSize={20} color="green" />
          </div>
        ),
    }
  ];

  const handleStatusUpdate = async (record, status) => {
    let isYes = await showCustomConfirmMessage({ message: `Are you sure you want to ${status} this?`, icon: status === "Confirmed" ? 'info' : 'warning' })
    const payload = { serviceBookingAptId: record.serviceBookingAptId, status: status, userId: record.userId };
    if (isYes) {
      try {
        await _api("POST", "Appointment/BookingConfirmation", payload, (res) => {
          if (res.isSuccess) {
            Toast.fire({ icon: "success", title: res?.message });
            _getAppointments();
          } else {
            Toast.fire({ icon: "error", title: res?.message });
          }
        });
      } catch (error) {
        console.error(error);
        Toast.fire({ icon: "error", title: "Action failed" });
      }
    }
  };

  const xlsColumns = [
    { title: "User Id", dataIndex: "userId" },
    { title: "Customer Name", dataIndex: "customerName" },
    { title: "Contact", dataIndex: "contactNumber" },
    { title: "Email", dataIndex: "email" },
    { title: "Vehicle", dataIndex: "vehicleName" },
    { title: "Service Type", dataIndex: "serviceType" },
    { title: "Current Mileage", dataIndex: "currentMileage" },
    { title: "Dealer", dataIndex: "dealerName" },
    { title: "Scheduled Date", dataIndex: "preferredDate" },
    { title: "Scheduled Time", dataIndex: "preferredTimeSlot" },
    { title: "Created On", dataIndex: "createDate" },
    { title: "Status", dataIndex: "status" },
  ]
  const handleExport = async () => {
    setBtnLoading(true);

    const payload = {
      appointmentId: 0,
      customerName: "",
      contactNumber: "",
      email: "",
      serviceType: "",
      status: "",
      vehicleName: "",
      preferredDate: "",
      createdDate: "",
      page: {
        pageNo: 0,
        numberOfRecords: 0,
      },
    };

    try {
      await _api("POST", "Appointment/GetAppointmentsById", payload, (res) => {
        if (res.isSuccess) {
          const krDateSahe = res.data.map((x) => ({
            ...x,
            preferredDate: _formatDate(x.preferredDate),
            createDate: _formatDate(x.createDate),
          }));

          setTimeout(() => {
            _exportToExcel({
              data: krDateSahe,
              columns: xlsColumns,
              fileName: "Service Appointments",
            });
            setBtnLoading(false);
          }, 1500);
        } else {
          setBtnLoading(false);
        }
      });
    } catch (error) {
      console.error(error);
      setBtnLoading(false);
    }
  };

  return (
    <>
      <Breadcrumb title="Appointments" />
      {filterBtnShow && (
        <Card className="mb-3">
          <div className="p-2 bg-white">
            <div className="row g-2">
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Customer Name"
                  value={filters.customerName}
                  onChange={(e) => setFilters({ ...filters, customerName: e.target.value })}
                />
              </div>

              <div className="col-md-3">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email"
                  value={filters.email}
                  onChange={(e) => setFilters({ ...filters, email: e.target.value })}
                />
              </div>

              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Contact No"
                  value={filters.contactNumber}
                  onChange={(e) => setFilters({ ...filters, contactNumber: e.target.value })}
                />
              </div>
              <div className="col-md-3">
                <Select
                  // options={vehicleOptions}
                  options={[
                    { label: "Alsvin", value: "alsvin" },
                    { label: "Karvaan", value: "karvaan" },
                    { label: "Oshan", value: "oshan" },
                    { label: "Sherpa", value: "sherpa" }
                  ]}
                  value={vehicleOptions.find(opt => opt.label === filters.vehicleName) || null}
                  onChange={(val) => setFilters({ ...filters, vehicleName: val?.label || "" })}
                  placeholder="Select Vehicle"
                  isClearable
                  styles={customStyleMd}
                />
              </div>
              <div className="col-md-3">
                <Select
                  options={serviceOptions}
                  value={filters.serviceType}
                  onChange={(val) => setFilters({ ...filters, serviceType: val })}
                  placeholder="Select Service"
                  isClearable
                  styles={customStyleMd}
                />
              </div>
              <div className="col-md-3">
                <Select
                  options={statusOptions}
                  value={filters.status}
                  onChange={(val) => setFilters({ ...filters, status: val })}
                  placeholder="Select Status"
                  isClearable
                  styles={customStyleMd}
                />
              </div>

              <div className="col-md-3">
                <Select
                  placeholder="Select Date Type"
                  value={filters.isCreatedDate}
                  onChange={(val) => setFilters({ ...filters, isCreatedDate: val })}
                  options={[
                    { value: true, label: "Created Date" },
                    { value: false, label: "Scheduled Date" },
                  ]}
                  isClearable
                  styles={customStyleMd}
                />
              </div>

              <div className="col-md-3">
                <DatePicker
                  format="YYYY-MM-DD"
                  value={filters.dateFrom ? dayjs(filters.dateFrom) : null}
                  onChange={(date) => setFilters({ ...filters, dateFrom: date })}
                  style={{ width: "100%" }}
                  disabledDate={(current) => {
                    if (current && current > dayjs().endOf("day")) return true;
                    if (filters.dateTo && current > dayjs(filters.dateTo)) return true;
                    return false;
                  }}
                  placeholder={filters.isCreatedDate?.value === true ? "Created Date (From)" : filters.isCreatedDate?.value === false ? "Preferred Date (From)" : "Select Date Type"}
                  disabled={filters.isCreatedDate === null || undefined}
                />
              </div>

              <div className="col-md-3">
                <DatePicker
                  format="YYYY-MM-DD"
                  value={filters.dateTo ? dayjs(filters.dateTo) : null}
                  onChange={(date) => setFilters({ ...filters, dateTo: date })}
                  style={{ width: "100%" }}
                  disabledDate={(current) => {
                    if (filters.dateFrom && current < dayjs(filters.dateFrom)) return true;
                    return false;
                  }}
                  placeholder={filters.isCreatedDate?.value === true ? "Created Date (To)" : filters.isCreatedDate?.value === false ? "Preferred Date (To)" : "Select Date Type"}
                  disabled={!filters.dateFrom && filters.isCreatedDate === null || undefined}
                />
              </div>

            </div>

            <div className="d-flex align-items-center justify-content-between gap-2 mt-3">
              <div className="flex-grow-1">
                {showExp.isShow && (
                  <Alert
                    showIcon
                    message={showExp.msg}
                    type="warning"
                  />
                )}
              </div>
              <div className="d-flex gap-2">
                <button className="btn btn-sm btn-outline-secondary" onClick={() => setFilterBtnShow(false)}>
                  Hide Filter
                </button>
                <button className="btn btn-sm btn-outline-secondary" onClick={handleReset}>
                  Reset Filters
                </button>
                <button className="btn btn-sm btn-primary" onClick={handleApply}>
                  Apply Filters
                </button>
              </div>
            </div>
          </div>
        </Card>
      )}
      <Card>
        <div className="d-flex justify-content-end" style={{ marginBottom: "10px" }}>
          {!filterBtnShow && (
            <button
              onClick={() => setFilterBtnShow(true)}
              className="btn btn-outline-primary-600 radius-3 d-flex align-items-center gap-2 px-14 py-6 text-sm mb-2"
              style={{ lineHeight: '1.2' }}
            >
              Filter Inquiries
              <Icon icon="mdi:filter-cog-outline" className="text-md" />
            </button>
          )}
          <button
            onClick={handleExport}
            className="btn btn-outline-primary-600 radius-3 d-flex align-items-center gap-2 px-14 py-6 text-sm mb-2"
            style={{ lineHeight: '1.2' }}
            disabled={btnLoading}
          >
            {btnLoading && (
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
            )}
            {btnLoading ? "Exporting..." : "Export to Excel"}
            <Icon icon="mdi:microsoft-excel" className="text-md" />
          </button>
        </div>
        <CustomTable
          columns={columns}
          dataSource={appointments}
          options={{
            withActions: false,
            loading: loading,
            bordered: true,
            size: "small",
            rowKey: "serviceBookingAptId",
            emptyText: "No appointments found",
            pageKey: 7
          }}
          pagination={{
            current: page,
            pageSize: pageSize,
            total: totalRecords,
            showSizeChanger: true,
            currentLength: appointments.length
          }}
          onChange={handleTableChange}
        />

      </Card>
      <CustomModal
        title="Appointment Details"
        show={isModalOpen.isOpen}
        size="lg"
        onHide={() => launchDetailModal(false)}
      >
        {isModalOpen.data && (
          <div className="row g-3">
            <div className="col-md-4">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Customer Name:</small>
                <div className="fw-semibold text-sm">{isModalOpen.data?.customerName}</div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Vehicle:</small>
                <div className="fw-semibold text-sm">{isModalOpen.data?.vehicleName}</div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Service Type:</small>
                <div className="fw-semibold text-sm">{isModalOpen.data?.serviceType}</div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Preferred Date:</small>
                <div className="fw-semibold text-sm">{_formatDate(isModalOpen.data?.preferredDate)}</div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Preferred Time:</small>
                <div className="fw-semibold text-sm">
                  {isModalOpen.data?.preferredTimeSlot
                    ? dayjs(`2000-01-01T${isModalOpen.data.preferredTimeSlot}`).format("hh:mm A")
                    : "-"}
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Email:</small>
                <div className="fw-semibold text-sm">{isModalOpen.data?.email}</div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Phone:</small>
                <div className="fw-semibold text-sm">{isModalOpen.data?.contactNumber}</div>
              </div>
            </div>

            <div className="col-12">
              <div className="border rounded p-3 bg-light shadow-sm">
                <small className="text-muted d-block mb-2">Complaint Description:</small>
                <div className="fw-semibold">{isModalOpen.data?.complaintDescription || "N/A"}</div>
              </div>
            </div>
          </div>
        )}
      </CustomModal>
    </>
  );
};

export default Appointments;